export default __webpack_public_path__ + "static/media/header6.9d55cddb.jpg";